module.exports = __webpack_public_path__ + "img/img-7.38988816.webp";